var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.857 200.827C82.86 200.827 46.2485 164.218 46.2485 119.219C46.2485 114.408 50.1488 110.51 54.9567 110.51C59.7674 110.51 63.6649 114.411 63.6649 119.219C63.6677 154.613 92.4618 183.41 127.857 183.41C163.249 183.41 192.045 154.613 192.045 119.221C192.045 114.411 195.943 110.513 200.754 110.513C205.564 110.513 209.462 114.414 209.462 119.221C209.465 164.218 172.853 200.827 127.857 200.827Z",
    fill: "#289117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.857 172.08C98.9557 172.08 75.3096 148.434 75.3096 119.533V53.9536C75.3096 25.0527 98.9557 1.40659 127.857 1.40659C156.757 1.40659 180.404 25.0527 180.404 53.9536V119.531C180.404 148.431 156.757 172.08 127.857 172.08Z",
    fill: "#289117"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.857 252.095C123.046 252.095 119.148 248.198 119.148 243.387V194.327C119.148 189.516 123.049 185.619 127.857 185.619C132.667 185.619 136.565 189.516 136.565 194.327V243.387C136.565 248.198 132.667 252.095 127.857 252.095Z",
    fill: "#289117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.224 254.307H98.4894C93.6787 254.307 89.7812 250.409 89.7812 245.598C89.7812 240.788 93.6815 236.89 98.4894 236.89H157.221C162.032 236.89 165.929 240.788 165.929 245.598C165.929 250.409 162.035 254.307 157.224 254.307Z",
    fill: "#289117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneGreen);
export default __webpack_public_path__ + "static/media/microphone-green.f47fd0e42a6ac7224e78b04e5117f6cd.svg";
export { ForwardRef as ReactComponent };